export default "<canvas width=\"500\" height=\"500\" #canvas></canvas>\n"